import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, Routes, Route, useNavigate } from 'react-router-dom';

// Main Certification Gallery Component (Ye aapke home/main page ke liye hai jo sirf 5 dikhayega)
export const CertificationGallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    const allCertificates = [
        { name: "TEC Type-1", img: "/tec_type1.png" },
        { name: "TEC Type-3", img: "/tec_type3.png" },
        { name: "ISO 14001:2015", img: "/iso_14001.png" },
        { name: "ISO 9001:2015", img: "/iso_9001.png" },
        { name: "Startup India", img: "/startup.png" },
        { name: "MSME ZED Bronze", img: "/zed_bronze.png" },
        { name: "Incorporation", img: "/incorporation.png" },
        { name: "IEC Certificate", img: "/iec.png" },
        { name: "Pollution Control", img: "/pollution.png" }
    ];

    return (
        <section className="py-20 bg-gray-50">
            <div className="container mx-auto px-4 md:px-12">
                <h2 className="text-4xl font-bold text-center mb-16 text-blue-900">
                    Our Certifications
                </h2>

                {/* Ek row mein 5 certificates ke liye grid-cols-5 set kiya hai */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
                    {allCertificates.slice(0, 5).map((cert, index) => (
                        <motion.div
                            whileHover={{ scale: 1.03 }}
                            key={index}
                            className="bg-white p-4 rounded-2xl shadow-xl border border-gray-100 flex flex-col items-center cursor-pointer justify-between"
                            onClick={() => setSelectedImage(cert)}
                        >
                            <img
                                src={cert.img}
                                alt={cert.name}
                                className="w-full h-48 object-contain rounded-lg"
                            />
                            <p className="mt-4 font-bold text-base text-gray-800 text-center">{cert.name}</p>
                        </motion.div>
                    ))}
                </div>

                {/* 5 se zyada hone par 'View All Certifications' button */}
                {allCertificates.length > 5 && (
                    <div className="text-center mt-12">
                        <Link to="/certifications">
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                className="px-10 py-4 bg-blue-900 text-white font-bold rounded-full hover:bg-orange-600 transition shadow-lg"
                            >
                                View All Certifications
                            </motion.button>
                        </Link>
                    </div>
                )}
            </div>

            {/* Modal for Zooming Image */}
            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedImage(null)}
                        className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
                    >
                        <motion.img
                            initial={{ scale: 0.8 }}
                            animate={{ scale: 1 }}
                            src={selectedImage.img}
                            alt={selectedImage.name}
                            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                        />
                        <button
                            className="absolute top-5 right-5 text-white text-3xl font-bold"
                            onClick={() => setSelectedImage(null)}
                        >
                            &times;
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
};


// Full Certifications Page (Yahan sare certificates show honge ek naye page par)
export const AllCertificationsPage = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();

    const allCertificates = [
        { name: "TEC Type-1", img: "/tec_type1.png" },
        { name: "TEC Type-3", img: "/tec_type3.png" },
        { name: "ISO 14001:2015", img: "/iso_14001.png" },
        { name: "ISO 9001:2015", img: "/iso_9001.png" },
        { name: "Startup India", img: "/startup.png" },
        { name: "MSME ZED Bronze", img: "/zed_bronze.png" },
        { name: "Incorporation", img: "/incorporation.png" },
        { name: "IEC Certificate", img: "/iec.png" },
        { name: "Pollution Control", img: "/pollution.png" }
    ];

    return (
        <div className="bg-gray-50 min-h-screen py-20">
            <div className="container mx-auto px-4 md:px-12">
                <button
                    onClick={() => navigate(-1)}
                    className="mb-8 px-6 py-2 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition"
                >
                    ← Back
                </button>

                <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-16 text-blue-900">
                    All Certifications
                </h1>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
                    {allCertificates.map((cert, index) => (
                        <motion.div
                            whileHover={{ scale: 1.03 }}
                            key={index}
                            className="bg-white p-4 rounded-2xl shadow-xl border border-gray-100 flex flex-col items-center cursor-pointer justify-between"
                            onClick={() => setSelectedImage(cert)}
                        >
                            <img
                                src={cert.img}
                                alt={cert.name}
                                className="w-full h-48 object-contain rounded-lg"
                            />
                            <p className="mt-4 font-bold text-base text-gray-800 text-center">{cert.name}</p>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Modal for Zooming Image */}
            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedImage(null)}
                        className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
                    >
                        <motion.img
                            initial={{ scale: 0.8 }}
                            animate={{ scale: 1 }}
                            src={selectedImage.img}
                            alt={selectedImage.name}
                            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                        />
                        <button
                            className="absolute top-5 right-5 text-white text-3xl font-bold"
                            onClick={() => setSelectedImage(null)}
                        >
                            &times;
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default CertificationGallery;